module.exports = __webpack_public_path__ + "img/FJ.d667d9ea.svg";